import { createContext } from "react";
import type { LeftMenuContextType } from "../@types/contexts/LeftMenu";

export const LeftMenuContext = createContext<LeftMenuContextType>({
  leftMenuWidth: 0,
  setLeftMenuWidth: () => {},
});
